import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-extend",
  "use": "icon-extend-usage",
  "viewBox": "0 0 33 43",
  "content": "<symbol viewBox=\"0 0 33 43\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-extend\">\r\n  <ellipse rx=\"2.04762\" ry=\"2.3044\" transform=\"matrix(-4.40687e-08 1 1 4.3357e-08 16.1306 15.0154)\" fill=\"white\" />\r\n  <ellipse rx=\"2.04762\" ry=\"2.3044\" transform=\"matrix(-4.40687e-08 1 1 4.3357e-08 16.1306 21.1589)\" fill=\"white\" />\r\n  <ellipse rx=\"2.04762\" ry=\"2.3044\" transform=\"matrix(-4.40687e-08 1 1 4.3357e-08 16.1306 27.3015)\" fill=\"white\" />\r\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol